// extracted by mini-css-extract-plugin
export var orderDetails = "_uv-2";
export var orderImage = "_uv-1";
export var orderMeta = "_uv-3";
export var orderSummary = "_uv-0";
export var rightArrow = "_uv-4";